import { AgColDefsI, paginationModel } from "src/app/shared/common-components/ag-grid/ag-grid.model";
import { TextRendererComponent } from "src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { StorageName } from "src/app/shared/enum/common-enum";


export class InsertUpdateSchemeModel {
    id:number;
    schemeName:string;
    duration:number;
    durationTypeId:number;
    redemptionOnId:number;
    installmentTypeId:string;
    installmentAmount:string= '0';
  }
  
  export class GetallCreateSchemeRequestModel extends paginationModel{
   page: number = 1;
  }

  export enum InstallmentType
{
    Daily = 'Daily',
    Weekly ='Weekly',
    Monthly = 'Monthly',
    Yearly = 'Yearly',
}

